import ALPHAQUANT_EXT_1 from "./ALPHAQUANT_EXT_1";

export default {
  ALPHAQUANT_EXT_1,
};
